import { ReactNode } from "react";
import { Loader2 } from "lucide-react";

interface GoogleStyleButtonProps {
  icon: ReactNode;
  label: string;
  onClick: () => void;
  isLoading?: boolean;
  disabled?: boolean;
  iconSize?: string;
}

export function GoogleStyleButton({
  icon,
  label,
  onClick,
  isLoading = false,
  disabled = false,
  iconSize = "h-5 w-5"
}: GoogleStyleButtonProps): JSX.Element {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled || isLoading}
      className="relative w-full h-[40px] bg-white border border-[#dadce0] rounded-[4px] hover:bg-[#f8f9fa] hover:border-[#d2e3fc] hover:shadow-[0_1px_2px_0_rgba(60,64,67,0.3),0_1px_3px_1px_rgba(60,64,67,0.15)] active:bg-[#eceff1] disabled:bg-[#f1f3f4] disabled:border-[#f1f3f4] disabled:cursor-not-allowed transition-all duration-200 flex items-center justify-center font-['Roboto','Arial',sans-serif] text-[14px] font-medium text-[#3c4043]"
    >
      {isLoading ? (
        <>
          <div className="absolute left-3 flex items-center justify-center">
            <Loader2 className={iconSize + " animate-spin text-[#1a73e8]"} />
          </div>
          <span>{label}</span>
        </>
      ) : (
        <>
          <div className={`absolute left-3 flex items-center justify-center ${iconSize}`}>{icon}</div>
          <span>{label}</span>
        </>
      )}
    </button>
  );
}
